import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  border-color: ${(p) => p.theme.palette.primary[100]};
  box-shadow: none;
  width: 100%;
`;
